import React from "react"

function ResponsibleDisclosureSEO() {
  return <meta name="description" content="Responsible Disclosure & Bug Bounty Policy - Nabestaandenloket" />
}

export default ResponsibleDisclosureSEO

